/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
// import _ from 'lodash';

import { Action, ActionType } from '../actionTypes/financialInvoiceActionTypes';
import { IFinancialInvoice as FinancialInvoice } from '../../models/financialInvoice';
import { IInvoiceReport1, IInvoiceReport2, IInvoiceFCReport1, IInvoiceFCReport2 } from '../../models/invoice';

export interface IFinancialInvoicesState {
    financialInvoices: FinancialInvoice[];
    financialInvoiceReport1: IInvoiceReport1;
    financialInvoiceReports2: IInvoiceReport2[];    
    financialInvoiceFCReport1: IInvoiceFCReport1;
    financialInvoiceFCReports2: IInvoiceFCReport2[];    
    loading: boolean;
    error: string | null,
}
const initialState = {
    financialInvoices: [],
    financialInvoiceReport1: {
        allReceived: 0,
        cp_pp_r: 0, 
        confirmedAmount: 0, 
        pp_pp_r: 0, 
        cvat_r: 0,
        confirmedInvoiceAmounts: 0,
        sentInvoiceAmounts: 0,
        aci_g_r: 0,
        icc_g_r: 0,
        aca_g_r: 0,
        acc_g_r: 0,
        ew_g_r: 0,
        ewcc_g_r: 0,    
        receivePercent: 0,
    },
    financialInvoiceReports2: [],    
    financialInvoiceFCReport1: {
        allFCReceived: 0,
        cp_pp_fc: 0, 
        confirmedFCAmount: 0, 
        pp_pp_fc: 0, 
        cvat_fc: 0,
        confirmedInvoiceFCAmounts: 0,
        sentInvoiceFCAmounts: 0,
        aci_g_fc: 0,
        icc_g_fc: 0,
        aca_g_fc: 0,
        acc_g_fc: 0,
        ew_g_fc: 0,
        ewcc_g_fc: 0,    
        receiveFCPercent: 0,
    },
    financialInvoiceFCReports2: [],        
    loading: false,
    error: null,   
};
export const FinancialInvoiceReducer: Reducer<IFinancialInvoicesState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_FINANCIALINVOICES:
        case ActionType.FETCH_FINANCIALINVOICEREPORT1:
        case ActionType.FETCH_FINANCIALINVOICEREPORT2:
        case ActionType.FETCH_FINANCIALINVOICEFCREPORT1:
        case ActionType.FETCH_FINANCIALINVOICEFCREPORT2:
        case ActionType.ADD_FINANCIALINVOICE:
        case ActionType.EDIT_FINANCIALINVOICE:
        case ActionType.DELETE_FINANCIALINVOICE:
            return { ...state, loading: true };

        case ActionType.FETCH_FINANCIALINVOICES_FAIL:
        case ActionType.FETCH_FINANCIALINVOICEREPORT1_FAIL:
        case ActionType.FETCH_FINANCIALINVOICEREPORT2_FAIL:
        case ActionType.FETCH_FINANCIALINVOICEFCREPORT1_FAIL:
        case ActionType.FETCH_FINANCIALINVOICEFCREPORT2_FAIL:
        case ActionType.ADD_FINANCIALINVOICE_FAIL:
        case ActionType.EDIT_FINANCIALINVOICE_FAIL:
        case ActionType.DELETE_FINANCIALINVOICE_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_FINANCIALINVOICE_SUCCESS:
            // console.log("action.payload: ", action.payload)
            return {
                ...state,
                financialInvoices: [ ...state.financialInvoices, action.payload ],
                loading: false
            };

        case ActionType.FETCH_FINANCIALINVOICES_SUCCESS:
            return {
                ...state,
                financialInvoices: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_FINANCIALINVOICEREPORT1_SUCCESS:
            return {
                ...state,
                financialInvoiceReport1: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_FINANCIALINVOICEREPORT2_SUCCESS:
            return {
                ...state,
                financialInvoiceReports2: action.payload.data,
                loading: false
            };                

        case ActionType.FETCH_FINANCIALINVOICEFCREPORT1_SUCCESS:
            return {
                ...state,
                financialInvoiceFCReport1: action.payload.data,
                loading: false
            };

        case ActionType.FETCH_FINANCIALINVOICEFCREPORT2_SUCCESS:
            return {
                ...state,
                financialInvoiceFCReports2: action.payload.data,
                loading: false
            };  

        case ActionType.EDIT_FINANCIALINVOICE_SUCCESS:
            const financialInvoice: FinancialInvoice = action.payload
            const index = state.financialInvoices.findIndex(itm => 
                Number(itm.invoiceid) === Number(financialInvoice.invoiceid)
            )
            const financialInvoicesPart1 = state.financialInvoices.slice(0, index)
            const financialInvoicesPart2 = state.financialInvoices.slice(index + 1)
            return {
                ...state,
                financialInvoices: [ ...financialInvoicesPart1, financialInvoice, ...financialInvoicesPart2 ],
                loading: false
            };
        case ActionType.DELETE_FINANCIALINVOICE_SUCCESS:
            return {
                ...state,
                financialInvoices: state.financialInvoices.filter(financialInvoice => financialInvoice.invoiceid !== action.payload),
            };

        default:
            return state;
    }
};
